import { Component, Input } from '@angular/core';

import { AuthService, GlobalMessageService } from '@spartacus/core';
import { FileDownloadService } from '@spartacus/storefront';
import { DocumentSpecificSearchService } from '../../../kbs-site-doc-search-page/service/Document-specific/document-specific-search.service';

@Component({
  selector: 'app-kb-document-grid',
  templateUrl: './kb-document-grid.component.html',
  styleUrls: ['./kb-document-grid.component.scss'],
  standalone: false
})
export class KbDocumentGridComponent {
  @Input('product') product: any;
  @Input() searchQuery: any;
  isLoggedIn: boolean = false;
  addfav !: boolean;
  tooltip: boolean = false;
  constructor(private AuthService: AuthService,
    private service: DocumentSpecificSearchService,
    private fileDownloadService: FileDownloadService) { }
  ngOnChanges() {
    if (this.product?.isFavorite) {
      this.addfav = true;
    }
  }
  ngOnInit() {
    this.AuthService.isUserLoggedIn().subscribe((data) => {
      if (data) {
        this.isLoggedIn = data;
      }
      else {
        this.isLoggedIn = false;
      }
    })
  }
  downloadPopup(doc: any) {
    console.log(doc);
    window.open(doc.url, `${doc.fileName}.pdf`);
    // this.fileDownloadService.download(doc, `${doc.fileName}.pdf`);
  }
  SubscribeDoc(data: any) {
    if (this.addfav) {
      this.unSubscribeDoc(data);
    } else {
      if (this.service.inPdp) {
        this.service.getDownloadPopup().subscribe((response: any) => {
          let payLoad = {
            code: data.code,
            email: response.displayUid,
            name: response.name,
            revision: data.revision,
            language: data.isoCode
          }
          this.service.addToFavFromPdp(payLoad).subscribe();
          // this.service.addToFavFromPdp(payLoad).subscribe((res: any) => {
          //   if (res.status == 'success') {
          //     this.globalmsgService.add({ key: 'common.text_notification_for_confirm_subscription' }, GlobalMessageType.MSG_TYPE_INFO);
          //   }
          // });
        });
      } else {
        this.service.getDownloadPopup().subscribe((response: any) => {
          let payLoad = {
            code: data.code,
            email: response.displayUid,
            name: response.name,
            revision: data.revision,
            language: data.isoCode
          }
          this.service.exceptPdpAddToFavFrom(payLoad).subscribe();
          // this.service.exceptPdpAddToFavFrom(payLoad).subscribe((res: any) => {
          //   if (res.status == 'success') {
          //     this.globalmsgService.add({ key: 'common.text_notification_for_confirm_subscription' }, GlobalMessageType.MSG_TYPE_INFO);
          //   }
          // });
        });
      }
    }


  }
  unSubscribeDoc(data: any) {
    if (this.service.inPdp) {
      this.service.removeFavFromPdp(data).subscribe();
    } else {
      this.service.removeFavDoc(data).subscribe();
    }

  }
}
